export class CostRoutes
{
    static Home = "/";
    //Cost
    static CostList = "/cost/list";
    static CostExplorer = "/cost/explorer";
    static CostEstimator = "/cost/estimator";
}